import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useQueryClient } from "@tanstack/react-query";

const useSaveProduct = ({ isEditMode, productId }) => {
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState(null);
  const queryClient = useQueryClient();

  const saveProduct = async (data) => {
    setIsSaving(true);
    setError(null);

    try {
      await new Promise((res) => setTimeout(res, 1000)); // fake delay

      if (isEditMode) {
        const updatedProduct = { ...data, id: productId };
        
        // Update React Query cache
        queryClient.setQueryData(["products"], (old) => {
          return old.map((p) => (p.id === productId ? updatedProduct : p));
        });
        
        return updatedProduct;
      } else {
        const newProduct = {
          ...data,
          id: uuidv4(), // generate ID
        };
        
        queryClient.setQueryData(["products"], (old) => {
          const safeOld = Array.isArray(old) ? old : [];
          return [...safeOld, newProduct];
        });

        console.log("New product:", newProduct);
        return newProduct;
      }
    } catch (err) {
      setError(err.message || "Unknown error");
      throw err;
    } finally {
      setIsSaving(false);
    }
  };

  return {
    saveProduct,
    isSaving,
    error,
  };
};

export default useSaveProduct;